import React from "react";

import { Chip, Stack, Typography } from "@mui/material";
import { StatusIcon } from "assets/material-custom-icons";
import { getStatusConfig, StatusPrompt } from "components/File-repository/Table/StatusPrompt";
import { usePrompt } from "hooks";
import { useActionHook } from "hooks/shared-hooks/use-action-hook";
import { useDealActions } from "store";
import { IFileRepo } from "store/types";

interface Props {
  fileData: IFileRepo;
  readOnly?: boolean;
  onFileUpdated?: (updatedFile: IFileRepo) => void;
}

export const DataExtractionStatus: React.FC<Props> = ({ fileData, readOnly, onFileUpdated }) => {
  const openPrompt = usePrompt();
  const { updateFileRepoAction } = useDealActions();
  const { action: patchFile } = useActionHook(updateFileRepoAction, {
    onSuccess: (data) => {
      onFileUpdated?.(data);
    }
  });

  const handleStatusClick = async (e: React.MouseEvent<HTMLDivElement>) => {
    if (readOnly) return;

    const result = await openPrompt({
      componentType: "popover",
      anchorEl: e.currentTarget as HTMLElement,
      Component: StatusPrompt,
      props: {
        currentStatus: fileData.file_status
      }
    });
    if (!result) return;
    await patchFile({ fileId: fileData.id, file_status: result.status });
  };

  const { label, bgcolor, iconColor, Icon } = getStatusConfig(fileData.file_status);

  return (
    <Stack direction="row" alignItems="center" gap="8px">
      <Stack direction="row" alignItems="center" gap="4px">
        <StatusIcon sx={{ fontSize: 14, color: "#496682" }} />
        <Typography noWrap sx={{ fontSize: "16px", fontWeight: 500, color: "#496682" }}>
          Status:
        </Typography>
      </Stack>
      <Chip
        disabled={readOnly}
        size="small"
        icon={<Icon sx={{ fontSize: 14, color: `${iconColor} !important` }} />}
        label={label}
        onClick={readOnly ? undefined : handleStatusClick}
        sx={{
          bgcolor,
          color: "#071f35",
          fontSize: "12px",
          height: "24px",
          cursor: readOnly ? "default" : "pointer",
          maxWidth: "100%",
          "&:hover": { bgcolor, opacity: 0.85 },
          "&.MuiChip-clickable:hover": { bgcolor }
        }}
      />
    </Stack>
  );
};
